import React from "react";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ConfirmationModal.css";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BlueBorderBtn from "../../common_btn/blueBorderBtn/BlueBorderBtn";
import BlueBtn from "../../common_btn/blueBtn/BlueBtn";

const ConfirmationModal = ({
  show = true,
  onHide,
  title = "Confirmation",
  statusTitle = "Are you sure?",
  message = "Please confirm whether you wish to proceed with this action.",
  // Single button props
  buttonText,
  onButtonClick,
  // Dual button props
  noButtonText,
  yesButtonText,
  onNoButtonClick,
  onYesButtonClick,
  className = "",
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
        className="StatusModal common_modal"
    >
      {/* Header Section */}
      <Modal.Header closeButton>
        <div className="modal_header_content">
          <button
            className="back-btn"
            onClick={onHide}
            aria-label="Back"
            type="button"
          >
            <span className="back-arrow">
              <FontAwesomeIcon icon={faCaretLeft} />
            </span>
          </button>

          <Modal.Title className="modal-custom-title">{title}</Modal.Title>
        </div>
      </Modal.Header>

      {/* Body Section */}
      <Modal.Body className="modal-custom-body">
        {/* Text Content */}
        <h5 className="status-title">{statusTitle}</h5>
        <p className="status-message">{message}</p>

        {/* Action Buttons */}
        <div className="actions_btn_holder">
          {buttonText ? (
            <BlueBorderBtn
              btnText={buttonText}
              onClick={onButtonClick || onHide}
            />
          ) : (
            <>
              {noButtonText && (
                <BlueBorderBtn
                  btnText={noButtonText}
                  onClick={onNoButtonClick || onHide}
                />
              )}
              {yesButtonText && (
                <BlueBtn
                  btnText={yesButtonText}
                  onClick={onYesButtonClick || onHide}
                />
              )}
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;